import { T_PRICING_PAGE_CONSTANTS } from './TYPES'

const DE_PRICING_PAGE_CONSTANTS: T_PRICING_PAGE_CONSTANTS = {
  TITLE: 'Abonnemente für Kinder',
  DESCRIPTION: [
    {
      label: 'All-Inclusive Budgetabonnement: Perfekt für jeden Bedarf!'
    },
    {
      newLine: true,
      label:
        'Erwachsene können die Plattform kostenlos nutzen, während Kinder eine'
    },
    {
      label: 'kostenlose Probephase von 15 Tagen genießen!',
      color: true
    }
  ]
}

export default DE_PRICING_PAGE_CONSTANTS
